import { Logger, sharedRef } from '@vue-storefront/core';
import type { Ref } from '@nuxtjs/composition-api';
import { useExpondoMiddleware } from '~/composables';
import { EXPONDO_MIDDLEWARE_ROUTES } from '~/constants/routes';
import { PersonalizedDiscount } from '~/types/discounts';
import { errorToString } from '~/helpers/error/errorToString';

export const usePersonalizedDiscount = () => {
  const personalizedDiscountLoading: Ref<boolean | null> = sharedRef(null, 'personalizedDiscountLoading');
  const personalizedDiscount: Ref<number | null> = sharedRef(null, 'personalizedDiscount');

  const { makeCommercetoolsRequest } = useExpondoMiddleware();

  const loadPersonalizedDiscount = async (cohortTier: string) => {
    personalizedDiscountLoading.value = true;
    try {
      const discountResponse = await makeCommercetoolsRequest<PersonalizedDiscount>({
        endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.GET_PERSONALIZED_DISCOUNTS,
        data: {
          cohortTier,
        },
      });
      if (!discountResponse) {
        personalizedDiscount.value = null;
        personalizedDiscountLoading.value = false;
        return;
      }
      const discountPermyriad = discountResponse?.data?.cartDiscount?.value?.permyriad;
      if (discountPermyriad && discountPermyriad > 0) {
        personalizedDiscount.value = discountPermyriad / 100;
      }
    } catch (err) {
      Logger.error('error.usePersonalizedDiscount', errorToString(err));
    } finally {
      personalizedDiscountLoading.value = false;
    }
  };

  return {
    loadPersonalizedDiscount,
    personalizedDiscount,
    personalizedDiscountLoading,
  };
};
